import axios from 'axios';
import {base_api} from './base';


export function getSurveyForms(includeDeleted) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/SurveyForms?includeDeleted=${includeDeleted}`, {headers});
}

export function getSurveyFormById(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/SurveyForms/GetSurveyFormById?id=${id}`, {headers});
}

export function getSurveyProcessedByEvent(leadId, eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  let api = `/SurveyForms/GetSurveyFormByEvent?leadId=${leadId}&eventId=${eventId}`;
  return axios.get(`${base_api + api}`, {headers});
}

export function getSurveyProcessed(includeDeleted, companyId, eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  let api = '';
  if (companyId) {
    api = `/SurveyForms/GetSurveyProcessed?includeDeleted=${includeDeleted}&companyId=${companyId}&eventId=${eventId}`;
  } else {
    api = `/SurveyForms/GetSurveyProcessed?includeDeleted=${includeDeleted}&eventId=${eventId}`;
  }
  return axios.get(`${base_api + api}`, {headers});
}

export function addSurveyForm(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/SurveyForms/AddSurveyForm`, data, {headers});
}

export function addSurveyFormList(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/SurveyForms/AddSurveyFormList`, data, {headers});
}

export function updateSurveyForm(surveyFormId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/SurveyForms/UpdateSurveyForm?surveyFormId=${surveyFormId}`, data, {headers});
}

export function updateSurveyFormList(surveyFormIds, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/SurveyForms/UpdateSurveyForm?surveyFormIds=${surveyFormIds}`, data, {headers});
}

export function deleteSurveyForm(id, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/SurveyForms/DeleteSurveyForm?id=${id}&hardDelete=${hardDelete}`, {headers});
}

export function deleteSurveyFormList(ids, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/SurveyForms/DeleteSurveyFormList?ids=${ids}&hardDelete=${hardDelete}`, {headers});
}





// WEBPACK FOOTER //
// ./src/services/SurveyForms.service.js